"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'carvana.body': '',
  'carvana.blue.primary': 'color.primary.v200',
  'carvana.blue.hover': 'color.primary.v300',
  'carvana.blue.medium': 'color.primary.v400',
  'carvana.blue.dark': 'color.primary.v600',
  'carvana.blue.pastel': 'color.primary.v100',
  'carvana.gray.background': 'color.neutral.v200',
  'carvana.gray.light': 'color.neutral.v300',
  'carvana.gray.medium': 'color.neutral.v400',
  'carvana.gray.dark': 'color.neutral.v500',
  'carvana.green.primary': 'color.validation.success',
  'carvana.red.primary': 'color.validation.error',
  'carvana.yellow.primary': 'color.validation.warning',
  'carvana.yellow.hover': 'color.secondary.v300',
  'carvana.yellow.pastel': 'color.secondary.v100',
  'carvana.white.primary': 'color.neutral.v100',
  'carvana.stroke.blue': 'color.primary.v700',
  'carvana.impersonationRed': ''
};